import {
  GET_POS_CATALOG,
  GET_POS_CATALOG_SUCCESS,
  GET_POS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getPointsOfSalesCatalogRed = (
  state: any,
  actions: any
) => {
  switch (actions.type) {
    case GET_POS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_POS_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    case GET_POS_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
